import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function createAnalysis(target_url, builder_context) {
  const { data } = await api.post("/analyses", { target_url, builder_context });
  return data;
}

export async function getAnalysis(id) {
  const { data } = await api.get(`/analyses/${id}`);
  return data;
}

export async function getStatus(id) {
  const { data } = await api.get(`/analyses/${id}/status`);
  return data;
}

export async function listAnalyses() {
  const { data } = await api.get("/analyses");
  return data;
}

export async function deleteAnalysis(id) {
  const { data } = await api.delete(`/analyses/${id}`);
  return data;
}

export async function fetchExport(id, kind) {
  const path = kind === "markdown" ? "markdown" : "feature-spec";
  const res = await fetch(`${API}/analyses/${id}/export/${path}`);
  if (!res.ok) throw new Error(`Export failed (${res.status})`);
  return await res.text();
}

// ---------- IQ Studio ----------

export async function studioMeta() {
  const { data } = await api.get("/studio/meta");
  return data;
}

export async function studioUnlock(code) {
  const { data } = await api.post("/studio/unlock", { code });
  return data;
}

export async function createStudioProject({ urls, analysis_ids, builder_context, name, code }) {
  const { data } = await api.post("/studio/projects", { urls, analysis_ids, builder_context, name, code });
  return data;
}

export async function getStudioProject(id) {
  const { data } = await api.get(`/studio/projects/${id}`);
  return data;
}

export async function listStudioProjects() {
  const { data } = await api.get("/studio/projects");
  return data;
}

export async function synthesizeStudio(id, code) {
  const { data } = await api.post(`/studio/projects/${id}/synthesize`, { code });
  return data;
}

export async function deleteStudioProject(id) {
  const { data } = await api.delete(`/studio/projects/${id}`);
  return data;
}

export function studioExportUrl(id, kind) {
  return `${API}/studio/projects/${id}/export/${kind}`;
}

export async function fetchStudioExport(id, kind) {
  const res = await fetch(studioExportUrl(id, kind));
  if (!res.ok) throw new Error(`Export failed (${res.status})`);
  return await res.text();
}

export async function studioQueueOnboarding(id) {
  const { data } = await api.post(`/studio/projects/${id}/onboarding`);
  return data; // { queued, onboarding_ready, onboarding_pending }
}
